import { render } from "./ReportList.vue?vue&type=template&id=5178ff54&scoped=true"
import script from "./ReportList.vue?vue&type=script&lang=js"
export * from "./ReportList.vue?vue&type=script&lang=js"

import "./ReportList.vue?vue&type=style&index=0&id=5178ff54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5178ff54"]])

export default __exports__